export const blue = "#165E9C";
export const red = "#BE0811";
export const white = "#FFFFFF";
export const grey = "#9D9FA2";
